module.exports = __webpack_public_path__ + "img/gyuszigumi6.7245f995.jpg";